import { ProjectDetailPreviewInfo } from '@pages/project-management/task/view/components/ProjectDetailPreviewInfo';

import AppTooltip from '@/components/app-tooltip/AppTooltip';
import { TagTaskType } from '@/components/common/task/TagTaskType';

import { DataViewer } from '@/utils/helpers/common';

import { IDetailTaskData } from '../../models';

import '../index.scss';

interface HeaderExternalRoleProps {
  detailData: IDetailTaskData;
}

const HeaderExternalRole = ({ detailData }: HeaderExternalRoleProps) => {
  return (
    <div className='view-task-project-header flex items-center justify-between gap-[16px] overflow-y-auto'>
      <div className='flex items-center gap-[8px] max-w-[560px]'>
        <TagTaskType type={detailData?.taskType ?? ''} />
        <AppTooltip className='truncate inline-block w-full' title={DataViewer.display(detailData?.taskName)}>
          <div className='text-lnk text-[24px] font-bold truncate inline-block w-full'>{DataViewer.display(detailData?.taskName)}</div>
        </AppTooltip>
      </div>
      {detailData && <ProjectDetailPreviewInfo project={detailData} className='ml-auto mr-[4px]' showMOT numTrunk={3} />}
    </div>
  );
};

export default HeaderExternalRole;
